import { Injectable } from '@angular/core';
import { SERVER_URL, API_GATEWAY_URL } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
//Services
import { AuthService } from './auth.service';
import { Storage } from '@ionic/storage';
import { MissionsService } from './missions.service';
import { ToolsService } from './tools.service';
import { ModalRedeemCouponPage } from '../modals/modal-redeem-coupon/modal-redeem-coupon.page';
import { ModalController } from '@ionic/angular';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  cache_categories: any;
  shooping_cart: any = []
  categories: any = []
  current_category: any;
  order: any;
  deliveryAddress: any;
  shopping_cart_valid: boolean = false;
  orderStates: any = { 'supplier_requested': 'Pendiente', 'supplier_sent': 'En camino', 'in_store': 'En camino', 'sent': 'En camino', 'arrived': 'Entregado', 'not_processed': 'Será entregado en máximo 15 días y serás notificado por correo electrónico', 'canceled': 'Cancelado', 'warranty_return': 'En Garantía', 'warranty_accepted': 'En Garantía', 'warranty_pending': 'En Garantía', 'warranty_disclaimed': 'En Garantía', 'pending': 'Pendiente', 'rejected': 'Rechazado' }
  reward_cart: any = [];
  buyed_cart: any;
  reward_mission: any;
  coupon_used: any;
  epayco_status_code
  totalIVAMoneyTax: number = 0;

  constructor(
    public http: HttpClient,
    public authService: AuthService,
    public storage: Storage,
    public missionsService: MissionsService,
    public toolsService: ToolsService,
    public modalController: ModalController,
    public configService: ConfigService
  ) {

  }


  /** 
    * Function to get all products
    * 
    * @author Brayan Garcia (bsgarciac)
    * @param {String} name - Name of the product
    * @returns {Object} - This functions returns a list of the products 
    * 
  **/
  getProductsLite(name): Promise<any> {
    const url = API_GATEWAY_URL + '/serverless/products/';
    //const headers = this.authService.getSimpleAuthHeaders();
    const params = {
      name,
      limit: '5',
      offset: '0'
    }
    if (this.authService.isLogged) {
      const headers = this.authService.getSimpleAuthHeaders();
      return this.http.get(url, { headers, params }).toPromise()
    }
    else return this.http.get(url, { params }).toPromise()
  }

  getProductState(productOrder) {
    // console.debug('productOrder', productOrder)
    let state = productOrder.state;
    if (state == 'not_processed') {
      let daysToArrive = productOrder.left_days_to_arrive;
      if (!daysToArrive || daysToArrive == 0) daysToArrive = 15;
      return 'En proceso, será entregado en máximo ' + daysToArrive + ' días y serás notificado por correo electrónico'
    }
    return this.orderStates[state]
  }

  getOrderState(order) {
    console.debug('order', order)
    let state = order.order_state;
    if (state == 'not_processed') {
      let daysToArrive = order.left_days_to_arrive;
      if (!daysToArrive || daysToArrive == 0) daysToArrive = 15;
      return 'En proceso, será entregado en máximo ' + daysToArrive + ' días y serás notificado por correo electrónico'
    }
    return this.orderStates[state]
  }


  /** 
    * Function to get all products
    * 
    * @author Brayan Garcia (bsgarciac)
    * @returns {Object} - This functions returns a list of the products 
    * 
  **/
  async getProducts(category_id, limit, offset, queryParams = null, rangeValue = null, order_by = '-created', favorite = null, promotion = null): Promise<any> {
    let route = ""
    if (favorite)
      route = SERVER_URL + '/products/';
    else
      route = API_GATEWAY_URL + '/serverless/products/';
    const url = route
    var params = {
      categories: '[' + await this.getAllChildren(category_id) + ']',
      order_by: order_by,
      limit: limit + '',
      offset: offset + ''
    }
    //queryParams = null
    if (queryParams) {
      if (queryParams.name) {
        params['name'] = queryParams.name
      }
      if (queryParams.tag) {
        let ids = []
        let tags = queryParams.tag.split('%')
        for (let tag of tags) {
          ids.push(tag.split('-')[0])
        }
        console.log("ids", ids)
        params['extra_categories'] = '[' + ids + ']'

      }
    }
    console.log(params)

    if (rangeValue) {
      params['min_price'] = rangeValue.lower
      params['max_price'] = rangeValue.upper
    }
    if (favorite)
      params['favorite'] = favorite
    if (promotion) params['category_promotion'] = promotion
    if (this.authService.isLogged) {
      const headers = this.authService.getSimpleAuthHeaders();
      return this.http.get(url, { headers, params }).toPromise()
        .then((result: any) => Promise.resolve(result.results));
    }
    else
      return this.http.get(url, { params }).toPromise()
        .then((result: any) => Promise.resolve(result.results));
  }


  /** 
    * Function to get detail of a product by id
    * 
    * @author Brayan Garcia (bsgarciac)
    * @param {Integer} id - Id of the product
    * @returns {Object} - This functions returns the product info
    * 
  **/
  getProductDetail(id) {
    const url = SERVER_URL + '/products/' + id + '/';
    if (this.authService.isLogged) {
      const headers = this.authService.getAuthHeaders();
      return this.http.get(url, headers).toPromise();
    }
    else
      return this.http.get(url).toPromise();
  }


  /** 
    * Function to buy a product
    * 
    * @author Brayan Garcia (bsgarciac)
    * @returns {Object} - This functions returns 200 if the sale was done
    * 
  **/
  buyProducts(cart_products) {
    const url = SERVER_URL + '/sales/sale-order/';
    const headers = this.authService.getAuthHeaders();
    const body = {
      address: {
        address: this.deliveryAddress.info,
        city: this.deliveryAddress.servientrega_city.city.name,
        city_code: this.deliveryAddress.servientrega_city.dane_code,
        cellphone: this.deliveryAddress.cellphone,
        document: this.deliveryAddress.document,
        name: this.deliveryAddress.person_name,
        neighborhood: this.deliveryAddress.neighborhood,
        additional_info: this.deliveryAddress.additional_info
      },
      cart_products: cart_products
    }
    if (this.reward_mission) body['is_mission_reward'] = true
    if (this.authService.additional_info) body['additional_params'] = this.authService.additional_info
    if (this.loadTotalMoney(cart_products) > 0) body['player_amount'] = this.loadTotalMoney(cart_products)
    return this.http.post(url, body, headers).toPromise();
  }

  buyCoupons(cart_products): Promise<any> {
    const url = SERVER_URL + '/sales/sale-order/';
    const headers = this.authService.getAuthHeaders();
    const body = {
      address: {},
      cart_products: cart_products
    }
    if (this.authService.additional_info) body['additional_params'] = this.authService.additional_info
    if (this.loadTotalMoney(cart_products) > 0) body['player_amount'] = this.loadTotalMoney(cart_products)
    return this.http.post(url, body, headers).toPromise();
  }


  async claimMissionReward() {
    try {
      await this.missionsService.claimReward(this.reward_mission)
      this.reward_mission = null
      this.reward_cart = []
    } catch (error) {
      console.error('[PRODUCT-SERVICE] claimMissionReward()', error)
    }
  }

  /** 
   * Function to load all categories
   * 
   * @author Brayan Garcia (bsgarciac)
   * @returns {Object} - This functions returns 200 if the sale was done
   * 
 **/
  async loadCategories(): Promise<any> {
    if (this.cache_categories) return this.cache_categories
    const url = API_GATEWAY_URL + '/serverless/categories/'
    this.cache_categories = await this.http.get(url).toPromise();
    return this.cache_categories;
  }

  /** 
    * Function get all children of parent category
    * 
    * @author Brayan Garcia (bsgarciac)
    * @param {integer} category_id - ID of the parent
    * @returns {Object} - This functions returns all the children
    * 
  **/
  async getSubCategories(category_id) {
    if (this.categories.length == 0)
      this.categories = await this.loadCategories()
    if (!category_id)
      category_id = 1//this.categories.find(item => item.parent_id == null).odoo_id; 
    var subCategories = this.categories.filter((item, index) => item.parent_id == category_id);
    return subCategories;
  }

  async setCurrentCategory(category_id) {
    if (this.categories.length == 0)
      this.categories = await this.loadCategories()
    console.log("CATEGORIES", this.categories)
    this.current_category = this.categories.find(item => item.odoo_id == category_id)
  }

  async getAllChildren(children_id) {
    var queue = [children_id]
    var childrens = []
    this.categories = await this.loadCategories();
    while (queue.length > 0) {
      var node = queue.pop()
      if (node)
        childrens.push(node)
      var subCategories = await this.getSubCategories(node);
      for (let subCategory of subCategories)
        queue.push(subCategory.odoo_id)
    }
    return childrens;
  }

  async getPathofCategories(children_id) {
    if (this.categories.length == 0)
      this.categories = await this.loadCategories()
    var node = this.categories.find(item => item.odoo_id == children_id);
    var path = []
    while (node) {
      path.push(node)
      node = this.categories.find(item => item.odoo_id == node.parent_id);
    }
    console.log('path', path)
    return path;
  }


  async loadShoppingCart() {
    this.shooping_cart = await this.getShoppingCart()
  }


  async addProduct(product) {
    this.shooping_cart.push(product)
    var res = await this.validatePromotion();
    if (res) this.shooping_cart = res
    this.updateShoppingCart();
  }

  async updateShoppingCartQuantity() {
    var res = await this.validatePromotion();
    if (res) this.shooping_cart = res
    this.updateShoppingCart();
  }

  removeProduct(product_id) {
    var item = this.shooping_cart.find(item => item.id == product_id);
    var index = this.shooping_cart.indexOf(item);
    this.shooping_cart.splice(index, 1);
    this.updateShoppingCart();
  }


  getShoppingCart(): Promise<any> {
    let url = SERVER_URL + '/crm/get_shopping_cart/';
    let headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise();
  }


  updateShoppingCart(): Promise<any> {
    let url = SERVER_URL + '/crm/update_shopping_cart/';
    let headers = this.authService.getAuthHeaders();
    let body = {
      shopping_cart: this.shooping_cart
    };
    return this.http.patch(url, body, headers).toPromise()
  }

  validatePromotion(): Promise<any> {
    console.log("this.validatePromotion")
    let url = SERVER_URL + '/crm/validate_promotion/';
    let headers = this.authService.getAuthHeaders();
    let body = {
      shopping_cart: this.shooping_cart
    };
    return this.http.post(url, body, headers).toPromise()
  }

  async availablePromotions() {
    var res: any = await this.validatePromotionAvailability();
    if (res) this.shooping_cart = res.shopping_cart
    return res.change
  }

  validatePromotionAvailability()/* :Promise<any> */ {
    let url = SERVER_URL + '/crm/validate_promotion_availability/';
    let headers = this.authService.getAuthHeaders();
    let body = {
      shopping_cart: this.shooping_cart
    };
    return this.http.post(url, body, headers).toPromise()
  }

  loadTotalPoints(products = this.shooping_cart) {
    var sum = 0;
    for (let product of products) {
      if (this.configService.company_info.allow_payment) {
        sum += (product.purchase.points - product.discount) * product.quantity
      }
      else {
        sum += (product.price - product.discount) * product.quantity
      }
    }
    return sum;
  }

  loadTotalDiscount(products = this.shooping_cart) {
    var sum = 0;
    var productsToBuy = this.shooping_cart.filter(item => item.quantity > 0)
    for (let product of productsToBuy) {
      sum += product.discount
    }
    return sum;
  }

  cartOnlyCoupons() {
    var productsToBuy = this.shooping_cart.filter(item => item.quantity > 0)
    for (let product of productsToBuy) {
      console.log(!product.brand_id || !product.mega_coupon || !product.is_wallet, !product.brand_i, !product.mega_coupon, !product.is_wallet)
      if (!product.brand_id && !product.mega_coupon && !product.is_wallet) return false;
    }
    return true;
  }

  cartOnlyInsurance() {
    var productsToBuy = this.shooping_cart.filter(item => item.quantity > 0)
    for (let product of productsToBuy) {
      if (!product.is_insurance)
        return false;
    }
    return true;
  }

  async deleteShoppingCart() {
    this.shooping_cart = [];
    await this.updateShoppingCart();
  }

  changeLikedState(product_id): Promise<any> {
    const url = SERVER_URL + '/products/favorite/';
    const headers = this.authService.getAuthHeaders();
    const body = {
      product_id
    }
    return this.http.post(url, body, headers).toPromise();
  }

  getOrders(offset, limit): Promise<any> {
    const url = SERVER_URL + '/sales/sale-order/';
    const headers = this.authService.getSimpleAuthHeaders();
    const params = {
      offset,
      limit
    }
    return this.http.get(url, { headers, params }).toPromise();
  }

  getTransactions(): Promise<any> {
    const url = SERVER_URL + '/points/transactions/';
    const headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise();
  }

  setClickOnRedeem(): Promise<any> {
    const url = SERVER_URL + '/crm/click_on_redeem/';
    const headers = this.authService.getAuthHeaders();
    return this.http.patch(url, {}, headers).toPromise();
  }


  validateCoupon(code): Promise<any> {
    const url = SERVER_URL + '/points/validate_coupon?code=' + code;
    const headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise();
  }


  redeemCoupon(coupon_id): Promise<any> {
    const url = SERVER_URL + '/points/redeem_coupon/';
    const headers = this.authService.getAuthHeaders();
    const body = { coupon_id }
    return this.http.post(url, body, headers).toPromise();
  }


  // Function to get quantum departments
  getDepartments(brand_id) {
    const url = SERVER_URL + '/products/brand_departments/';
    const headers = this.authService.getAuthHeaders();
    const body = { brand_id };
    return this.http.post(url, body, headers).toPromise();
  }

  // Function to validate promotion existence 
  validatePromotionExistence(): Promise<any> {
    const url = SERVER_URL + '/points/validate_promotion_existence';
    const headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise().catch((err) => {
      console.debug("Error validating promotion existence", err);
      return null;
    });
  }

  getProductsTags(category_id) {
    const url = SERVER_URL + '/products/get_product_extra_categories/';
    let params = {
      category_id
    }
    return this.http.get(url, { params }).toPromise();
  }

  //Insurance
  createInsuranceQuotation(insurance): Promise<any> {
    const url = SERVER_URL + '/products/create_insurance_quotation/';
    const headers = this.authService.getAuthHeaders();

    const body = {
      "plate": insurance[0].formControl.value,
      "mobile_phone": insurance[1].formControl.value,
      "name": insurance[2].formControl.value.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
      "last_name": insurance[3].formControl.value.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
      "identification_type": insurance[4].formControl.value,
      "identification": insurance[5].formControl.value,
      "email": insurance[6].formControl.value,
      "address": insurance[7].formControl.value,
    }
    return this.http.post(url, body, headers).toPromise();
  }

  updateInsuranceQuotation(id, vehicleTypeId): Promise<any> {
    const url = SERVER_URL + '/products/update_insurance_quotation/';
    const headers = this.authService.getAuthHeaders();

    const body = {
      "insurance_id": id,
      "vehicle_type_id": vehicleTypeId
    }
    return this.http.post(url, body, headers).toPromise();
  }

  validateInsuranceQuotation(id): Promise<any> {
    const url = SERVER_URL + '/products/validate_insurance_quotation/';
    const headers = this.authService.getAuthHeaders();

    const body = {
      "insurance_id": id
    }
    return this.http.post(url, body, headers).toPromise();
  }

  //function to get the special product
  getSpecialProduct() {
    const url = SERVER_URL + '/products/get_special_product/';
    return this.http.get(url).toPromise();
  }

  createTargetProduct(product_id, due_date) {
    const url = SERVER_URL + '/products/create_update_target_product/';
    const headers = this.authService.getAuthHeaders();
    const body = {
      product_id,
      due_date
    }
    return this.http.post(url, body, headers).toPromise();
  }

  /**
   * Gets the target products of the user
   * @param user_id 
   * @param limit 
   * @param offset 
   */
  getTargetProducts(user_id, offset, limit): Promise<any> {
    const url = SERVER_URL + '/products/get_target_products/';
    const headers = this.authService.getSimpleAuthHeaders();
    const params = {
      user_id: user_id,
      offset: offset,
      limit: limit
    }

    return this.http.get(url, { headers, params }).toPromise();
  }

  /**
   * Cancels target product
   * @param product_id 
   * @param user_id
   * @returns 
   */
  cancelTargetProduct(product_id) {
    const url = SERVER_URL + '/products/cancel_target_product/';
    const headers = this.authService.getAuthHeaders();
    const body = {
      product_id: product_id,
    }

    return this.http.post(url, body, headers).toPromise();
  }

  /* 
  Return True if there are less than 15 products
  Return false if there are more than 15 products
  */
  validateNumberOfProducts(product, quantity) {
    let result = false
    let products_counter = 0

    for (let product of this.shooping_cart) {

      products_counter += product.quantity
      if (products_counter > 10) {

        return false
      }
    }
    if ((products_counter + quantity) > 10) {
      return false
    }
    return true
  }

  normaliseProduct(product, allow_payment, money, points, rangeValue, maxRangeValue, minRangeValue) {
    product.purchase = {
      points,
      money,
      rangeValue,
      maxRangeValue,
      minRangeValue
    }

    return product
  }

  loadTotalMoney(products = this.shooping_cart) {
    var sum = 0;
    for (let product of products) {
      if (this.configService.company_info.allow_payment) {
        sum += product.purchase.money * product.quantity
      }
    }
    return sum;
  }

  getProductTax(product) {
    if (!product.mega_coupon && product.brand_id == '') {
      return product.purchase.money * (product.taxes / 100);
    } else {
      const subtotal = product.purchase.money;
      const ivaTax = (subtotal - (subtotal / (1 + (product.profit / 100)))) * (19 / 100);
      return Math.ceil(ivaTax);
    }
  }

  loadTotalTax(products = this.shooping_cart) {
    var sum = 0;
    for (let product of products) {
      if (this.configService.company_info.allow_payment) {
        sum += this.getProductTax(product) * product.quantity;
      }
    }
    return sum;
  }

  updateOrderEpayco(ref, order_id): Promise<any> {
    const url = SERVER_URL + '/sales/update-epayco-reference/';
    const headers = this.authService.getAuthHeaders();
    const body = {
      ref,
      order_id
    }
    return this.http.post(url, body, headers).toPromise();
  }

  validateMaxMoneyValue(rangeValue) {
    if (this.configService.company_info.money_percentage > 0) {
      let percent_max_range = 100 - this.configService.company_info.money_percentage
      let max_range = Math.ceil(percent_max_range * rangeValue / 100)
      if (rangeValue > max_range) {
        return max_range
      }
    }
    else return rangeValue
  }

  saveExternalUserInfo(data) {
    const url = SERVER_URL + '/crm/create_external_user_info/';
    const headers = this.authService.getAuthHeaders();
    const body = {
      "name_user": data.name,
      "email_user": data.email,
      "document": data.document,
    }
    return this.http.post(url, body, headers).toPromise();
  }

  getExternalUserInfo() {
    const url = SERVER_URL + '/crm/get_external_user_info/';
    const headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise();
  }

  deleteExternalUserInfo(id) {
    const url = SERVER_URL + '/crm/delete_external_user_info/';
    const headers = this.authService.getAuthHeaders();
    const data = {
      "id": id
    }
    return this.http.post(url, data, headers).toPromise();
  }


}
